import { render, staticRenderFns } from "./ExtraFieldsEdit.vue?vue&type=template&id=e42ae7c6&scoped=true"
import script from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldsEdit.vue?vue&type=style&index=0&id=e42ae7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42ae7c6",
  null
  
)

export default component.exports